module.exports = __webpack_public_path__ + "static/img/tel1.49d74130.png";